exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@media(max-width: 575px){.no-gutters-rows{margin-right:0 !important;margin-left:0 !important}.right-margin{margin-right:.25rem !important;padding-left:0px !important;padding-right:0px !important}.left-margin{margin-left:.25rem !important;padding-left:0px !important;padding-right:0px !important}.padding{padding-left:.25rem !important;padding-right:.25rem !important}}.btn-back{width:32% !important}@media(max-width: 575px){.btn-back{width:80% !important}}.btn-back-alignment{text-align:left;padding-left:40px}@media(max-width: 575px){.btn-back-alignment{padding-left:15px}}@media(min-width: 576px){.btn-back-alignment{padding-left:15px}}.btn-next-alignment{text-align:right;padding-right:40px}@media(min-width: 576px){.btn-next-alignment{padding-right:15px}}@media(max-width: 575px){.btn-next-alignment{padding-right:15px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Quoters/Common/SubComponents/BackNext.scss
// module id = 7494
// module chunks = 11